import {
    demonPrefixes, demonSuffixes,
    trDemonPrefixes, trDemonSuffixes,
    frDemonPrefixes, frDemonSuffixes,
    esDemonPrefixes, esDemonSuffixes,
    deDemonPrefixes, deDemonSuffixes,
    ptDemonPrefixes, ptDemonSuffixes,
    arDemonPrefixes, arDemonSuffixes,
    hiDemonPrefixes, hiDemonSuffixes,
    jaDemonPrefixes, jaDemonSuffixes,
    koDemonPrefixes, koDemonSuffixes,
    idDemonPrefixes, idDemonSuffixes,
    viDemonPrefixes, viDemonSuffixes,
    ruDemonPrefixes, ruDemonSuffixes,
    itDemonPrefixes, itDemonSuffixes,
    plDemonPrefixes, plDemonSuffixes,
    nlDemonPrefixes, nlDemonSuffixes,

    slasherPrefixes, slasherSuffixes,
    trSlasherPrefixes, trSlasherSuffixes,
    frSlasherPrefixes, frSlasherSuffixes,
    esSlasherPrefixes, esSlasherSuffixes,
    deSlasherPrefixes, deSlasherSuffixes,
    ptSlasherPrefixes, ptSlasherSuffixes,
    arSlasherPrefixes, arSlasherSuffixes,
    hiSlasherPrefixes, hiSlasherSuffixes,
    jaSlasherPrefixes, jaSlasherSuffixes,
    koSlasherPrefixes, koSlasherSuffixes,
    idSlasherPrefixes, idSlasherSuffixes,
    viSlasherPrefixes, viSlasherSuffixes,
    ruSlasherPrefixes, ruSlasherSuffixes,
    itSlasherPrefixes, itSlasherSuffixes,
    plSlasherPrefixes, plSlasherSuffixes,
    nlSlasherPrefixes, nlSlasherSuffixes,

    cosmicPrefixes, cosmicSuffixes,
    trCosmicPrefixes, trCosmicSuffixes,
    frCosmicPrefixes, frCosmicSuffixes,
    esCosmicPrefixes, esCosmicSuffixes,
    deCosmicPrefixes, deCosmicSuffixes,
    ptCosmicPrefixes, ptCosmicSuffixes,
    arCosmicPrefixes, arCosmicSuffixes,
    hiCosmicPrefixes, hiCosmicSuffixes,
    jaCosmicPrefixes, jaCosmicSuffixes,
    koCosmicPrefixes, koCosmicSuffixes,
    idCosmicPrefixes, idCosmicSuffixes,
    viCosmicPrefixes, viCosmicSuffixes,
    ruCosmicPrefixes, ruCosmicSuffixes,
    itCosmicPrefixes, itCosmicSuffixes,
    plCosmicPrefixes, plCosmicSuffixes,
    nlCosmicPrefixes, nlCosmicSuffixes
} from '@/constants/horrorNames';

interface LocaleData {
    demonPrefixes: string[];
    demonSuffixes: string[];
    slasherPrefixes: string[];
    slasherSuffixes: string[];
    cosmicPrefixes: string[];
    cosmicSuffixes: string[];
}

const localeDataMap: Record<string, LocaleData> = {
    en: { demonPrefixes, demonSuffixes, slasherPrefixes, slasherSuffixes, cosmicPrefixes, cosmicSuffixes },
    tr: { demonPrefixes: trDemonPrefixes, demonSuffixes: trDemonSuffixes, slasherPrefixes: trSlasherPrefixes, slasherSuffixes: trSlasherSuffixes, cosmicPrefixes: trCosmicPrefixes, cosmicSuffixes: trCosmicSuffixes },
    fr: { demonPrefixes: frDemonPrefixes, demonSuffixes: frDemonSuffixes, slasherPrefixes: frSlasherPrefixes, slasherSuffixes: frSlasherSuffixes, cosmicPrefixes: frCosmicPrefixes, cosmicSuffixes: frCosmicSuffixes },
    es: { demonPrefixes: esDemonPrefixes, demonSuffixes: esDemonSuffixes, slasherPrefixes: esSlasherPrefixes, slasherSuffixes: esSlasherSuffixes, cosmicPrefixes: esCosmicPrefixes, cosmicSuffixes: esCosmicSuffixes },
    de: { demonPrefixes: deDemonPrefixes, demonSuffixes: deDemonSuffixes, slasherPrefixes: deSlasherPrefixes, slasherSuffixes: deSlasherSuffixes, cosmicPrefixes: deCosmicPrefixes, cosmicSuffixes: deCosmicSuffixes },
    pt: { demonPrefixes: ptDemonPrefixes, demonSuffixes: ptDemonSuffixes, slasherPrefixes: ptSlasherPrefixes, slasherSuffixes: ptSlasherSuffixes, cosmicPrefixes: ptCosmicPrefixes, cosmicSuffixes: ptCosmicSuffixes },
    ar: { demonPrefixes: arDemonPrefixes, demonSuffixes: arDemonSuffixes, slasherPrefixes: arSlasherPrefixes, slasherSuffixes: arSlasherSuffixes, cosmicPrefixes: arCosmicPrefixes, cosmicSuffixes: arCosmicSuffixes },
    hi: { demonPrefixes: hiDemonPrefixes, demonSuffixes: hiDemonSuffixes, slasherPrefixes: hiSlasherPrefixes, slasherSuffixes: hiSlasherSuffixes, cosmicPrefixes: hiCosmicPrefixes, cosmicSuffixes: hiCosmicSuffixes },
    ja: { demonPrefixes: jaDemonPrefixes, demonSuffixes: jaDemonSuffixes, slasherPrefixes: jaSlasherPrefixes, slasherSuffixes: jaSlasherSuffixes, cosmicPrefixes: jaCosmicPrefixes, cosmicSuffixes: jaCosmicSuffixes },
    ko: { demonPrefixes: koDemonPrefixes, demonSuffixes: koDemonSuffixes, slasherPrefixes: koSlasherPrefixes, slasherSuffixes: koSlasherSuffixes, cosmicPrefixes: koCosmicPrefixes, cosmicSuffixes: koCosmicSuffixes },
    id: { demonPrefixes: idDemonPrefixes, demonSuffixes: idDemonSuffixes, slasherPrefixes: idSlasherPrefixes, slasherSuffixes: idSlasherSuffixes, cosmicPrefixes: idCosmicPrefixes, cosmicSuffixes: idCosmicSuffixes },
    vi: { demonPrefixes: viDemonPrefixes, demonSuffixes: viDemonSuffixes, slasherPrefixes: viSlasherPrefixes, slasherSuffixes: viSlasherSuffixes, cosmicPrefixes: viCosmicPrefixes, cosmicSuffixes: viCosmicSuffixes },
    ru: { demonPrefixes: ruDemonPrefixes, demonSuffixes: ruDemonSuffixes, slasherPrefixes: ruSlasherPrefixes, slasherSuffixes: ruSlasherSuffixes, cosmicPrefixes: ruCosmicPrefixes, cosmicSuffixes: ruCosmicSuffixes },
    it: { demonPrefixes: itDemonPrefixes, demonSuffixes: itDemonSuffixes, slasherPrefixes: itSlasherPrefixes, slasherSuffixes: itSlasherSuffixes, cosmicPrefixes: itCosmicPrefixes, cosmicSuffixes: itCosmicSuffixes },
    pl: { demonPrefixes: plDemonPrefixes, demonSuffixes: plDemonSuffixes, slasherPrefixes: plSlasherPrefixes, slasherSuffixes: plSlasherSuffixes, cosmicPrefixes: plCosmicPrefixes, cosmicSuffixes: plCosmicSuffixes },
    nl: { demonPrefixes: nlDemonPrefixes, demonSuffixes: nlDemonSuffixes, slasherPrefixes: nlSlasherPrefixes, slasherSuffixes: nlSlasherSuffixes, cosmicPrefixes: nlCosmicPrefixes, cosmicSuffixes: nlCosmicSuffixes },
};

export interface HorrorNameGeneratorOptions {
    count?: number;
    style?: 'demon' | 'slasher' | 'cosmic' | 'any';
    locale?: string;
}

export function generateHorrorNames(options: HorrorNameGeneratorOptions = {}): string[] {
    const count = options.count || 10;
    const style = options.style || 'any';
    const locale = options.locale || 'en';
    const names: string[] = [];

    const data = localeDataMap[locale] || localeDataMap['en'];

    for (let i = 0; i < count; i++) {
        let currentStyle = style;
        if (currentStyle === 'any') {
            const styles = ['demon', 'slasher', 'cosmic'];
            currentStyle = styles[Math.floor(Math.random() * styles.length)] as 'demon' | 'slasher' | 'cosmic';
        }

        let prefix = '';
        let suffix = '';

        switch (currentStyle) {
            case 'demon':
                prefix = data.demonPrefixes[Math.floor(Math.random() * data.demonPrefixes.length)];
                suffix = data.demonSuffixes[Math.floor(Math.random() * data.demonSuffixes.length)];
                break;
            case 'slasher':
                prefix = data.slasherPrefixes[Math.floor(Math.random() * data.slasherPrefixes.length)];
                suffix = data.slasherSuffixes[Math.floor(Math.random() * data.slasherSuffixes.length)];
                break;
            case 'cosmic':
                prefix = data.cosmicPrefixes[Math.floor(Math.random() * data.cosmicPrefixes.length)];
                suffix = data.cosmicSuffixes[Math.floor(Math.random() * data.cosmicSuffixes.length)];
                break;
        }

        names.push(`${prefix}${suffix}`);
    }

    return names;
}
